import { Component, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Router, RouterOutlet, NavigationStart } from '@angular/router';
import { EMPTY } from 'rxjs';

import { NavbarComponent } from '../navbar/navbar.component';
import { HeaderComponent } from '../header/header.component';
import { SharedDataService } from '../../services/shared-data.service';
import { HeaderConfig } from '../../shared/types';
import { CommonRoutes } from '../../shared/constant';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';
import { TaxonomyService } from '../../services/taxonomy.service';
import { ActionService } from '../../services/action.service';


@Component({
  selector: 'app-full-layout',
  standalone: true,
  imports: [MatSidenavModule, HeaderComponent, NavbarComponent, CommonModule, HttpClientModule, RouterOutlet, BottomSheetComponent],
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
})
export class FullLayoutComponent implements OnInit {
  collapsed: boolean = true;
  headerConfig: HeaderConfig = { title: 'Insights Dashboard' };

  constructor(
    private sharedDataService: SharedDataService,
    private router: Router,
    private taxonomyService: TaxonomyService,
    public actionService: ActionService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const routeLink = event.url.slice(1);
        this.updateHeaderTitleFromRouteLink(routeLink);
      }
    });

    this.sharedDataService.getDashboardState().subscribe({
      next: (dashboardData) => {
        if (dashboardData.navBarData.routeLink !== 'conversation-insights') {
          this.router.navigate([dashboardData.navBarData.routeLink]);
        }
      },
      error: () => this.handleError(),
    });
  }

  updateHeaderTitleFromRouteLink(url: string) {
    const matchedRoute = CommonRoutes.find((route) => route.routeLink === url);
    // DASHBOARD TITLE CONSIDERING ROUTE
    if (matchedRoute) {
      this.headerConfig.title = matchedRoute.title;
      this.taxonomyService.updateTaxoCheckFlag(matchedRoute.title); // Set signal value

      switch (matchedRoute.title) {
        case "conversation-insights":
          this.headerConfig.title = "Insights Dashboard";
          break;
      }
    } else {
      // IF URL INCLUDES TAXONOMY-DASHBOARD
      if (url.includes("taxonomy-dashboard")) {
        this.headerConfig.title = "Taxonomy";

        const routeValue: string = (matchedRoute as unknown as { routeLink: string })?.routeLink ?? '';
        // IF URL IS EQUAL TO TAXONOMY-DASHBOARD
        if (url === "taxonomy-dashboard" && routeValue === "taxonomy-dashboard") {
          this.taxonomyService.updateTaxoCheckFlag("taxonomy-dashboard");
        } else {
          this.taxonomyService.updateTaxoCheckFlag("taxonomy-dashboard-subpage");
        }
      }
    }
  }


  onCollapsedChanged(collapsed: boolean) {
    this.collapsed = collapsed;
  }

  handleError() {
    console.error('Failed to load dashboard data');
    return EMPTY;
  }
}
